export const actions = {
    setMenu: "SET_MENU"
};

export function setMenu(menu) {
    return {type: actions.setMenu, menu}
}

const INITIAL_STATE = {
    menu: ''
};

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actions.setMenu:
            return {
                ...state,
                menu: action.menu
            };
        default:
            return {
                ...state
            };
    }
}



// WEBPACK FOOTER //
// ./src/modules/application/menu.js